import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { PivotTableService } from '@shared/wound-tracker/pivot-table/pivot-table.service';

import { HttpErrorHandler } from './http';
import { AIService, AuthenticationService, AuthorizationPacimService, AuthorizationService, BroadcastNoteService, DiagnosisPacimService, INotesService, NotesDialogManagerService, NotesService, SDoHManagementService } from './service';
import { ShellService } from '@mynexus/mfe-core';

@NgModule({
  declarations: [],
  exports: [CommonModule], imports: [CommonModule], providers: [
    AIService,
    AuthenticationService,
    AuthorizationPacimService,
    AuthorizationService,
    BroadcastNoteService,
    DiagnosisPacimService,
    HttpErrorHandler,
    NotesService,
    NotesDialogManagerService,
    SDoHManagementService,
    ShellService,
    PivotTableService,
    {
      provide: INotesService,
      useClass: NotesService
    },
    provideHttpClient(withInterceptorsFromDi()),
  ]
})
export class CoreModule {
}
